module.exports = __webpack_public_path__ + "img/1.de52d61f.png";